var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "checkmark_svg__icon"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.686 13.513a.89.89 0 0 0 .78-.413l5.968-9.293c.133-.21.19-.387.19-.558 0-.45-.317-.762-.774-.762-.311 0-.502.114-.692.413l-5.504 8.728L3.83 8.003c-.19-.247-.388-.349-.667-.349-.457 0-.787.324-.787.768 0 .197.07.387.235.584l3.288 4.1c.222.28.457.407.787.407Z",
    fill: "currentColor"
  })));
};

export default SvgCheckmark;